import { FilmFilterKey, FilterType, addSelectedSite } from '@vista-digital/occ-domain'
import {
    FilmFiltersConfig,
    ShowtimeFiltersConfig,
} from '@vista-digital/occ-ui/src/lib/components/composite-filter/types/config'
import { SingleFilterDisplayMode, SingleFilterProps } from '@vista-digital/occ-ui'
import { defaultSingleFilterConfig } from '@vista-digital/occ-ui/src/lib/components/single-filter/types/config'
import { defaultSingleFilterProps } from '@vista-digital/occ-ui/src/lib/components/single-filter/types/props'

import { CompositeFilterPropsFromCms } from '../../components/'
import { propsFromCmsBase } from '../../cmsTypes'
import { CompositeFilterPropsApi } from '../compositeFilter'
import { SingleFilterPropsApi } from '../singleFilter'
import { LocateMePropsApi } from '../locateMe'
import { LocateMeProps } from '../locateMe/LocateMeComponent'

export enum OmniFilterModes {
    Film = 'film',
    Showtime = 'showtime',
}

export interface OmniFilterInitialProps extends propsFromCmsBase {
    config: {
        filterId: string
        filterMode: OmniFilterModes
        singleFilterComponent: {
            enabled: boolean
        }
        sitePickerComponent: {
            enabled: boolean
        }
        locateMeComponent: {
            enabled: boolean
        }
    }
    subcomponentProps: {
        singleFilterComponent?: SingleFilterPropsApi
        locateMeComponent?: LocateMePropsApi
        compositeFilterComponent: CompositeFilterPropsApi
    }
}

export interface OmniFilterProps {
    singleFilterProps: SingleFilterProps
    locateMeProps: LocateMeProps
    compositeFilterProps: CompositeFilterPropsFromCms
}

export const filterConfigShowtime: ShowtimeFiltersConfig = {
    attribute: {
        enabled: true,
        isMultiselect: true,
        index: 1,
    },
    genre: {
        enabled: true,
        isMultiselect: true,
        index: 0,
    },
    event: {
        enabled: false,
        isMultiselect: true,
        index: 2,
    },
}

export const filterConfigFilm: FilmFiltersConfig = {
    category: {
        enabled: false,
        isMultiselect: false,
        index: 0,
    },
    attribute: {
        enabled: false,
        isMultiselect: false,
        index: 0,
    },
    genre: {
        enabled: true,
        isMultiselect: true,
        index: 0,
    },
    event: {
        enabled: true,
        isMultiselect: true,
        index: 1,
    },
}

export function getOmniFilterSubcomponentProps(props: OmniFilterInitialProps): OmniFilterProps {
    const { config, subcomponentProps } = props

    const handleGetNearestSite = site => {
        addSelectedSite(site.id)
    }

    const locateMeProps = {
        displayText: subcomponentProps.locateMeComponent,
        onGetNearestSite: handleGetNearestSite,
    }

    const singleFilterProps: SingleFilterProps = {
        ...defaultSingleFilterProps,
        filterId: config.filterId,
        displayText: subcomponentProps.singleFilterComponent,
        config: {
            ...defaultSingleFilterConfig,
            filterType: FilterType.Film,
            filter: FilmFilterKey.Category,
            displayMode: SingleFilterDisplayMode.PrimaryTab,
            showAllOption: true,
            enableSearch: false,
        },
    }

    return {
        singleFilterProps: singleFilterProps,
        locateMeProps: locateMeProps,
        compositeFilterProps: {
            filterId: config.filterId,
            filterMode: config.filterMode,
            displayText: {
                ...subcomponentProps.compositeFilterComponent,
            },
        },
    }
}
